import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Slider, Typography } from "@mui/material";
import { Business, Person } from "@mui/icons-material";
import { RadioCardGroup, ChoiceToggle, Button, PageHeader } from "@components/ui_v2";
import { PATHS_TOFU_V2 } from "@helpers/constantes";
import { formatCurrencyWhole } from "@helpers/funciones";

const MIN = 100000;
const MAX = 5000000;
const STEP = 50000;
const PLAZOS = [12, 24, 36, 48, 60];
const TASA_ANUAL = 0.35;

export const Cotizador = () => {
  const navigate = useNavigate();
  const [regimen, setRegimen] = useState<"moral" | "fisica">("moral");
  const [monto, setMonto] = useState(500000);
  const [plazo, setPlazo] = useState(24);

  const onNext = () => navigate(PATHS_TOFU_V2.crearCuenta.path);

  const i = TASA_ANUAL / 12;
  const cuota = (monto * (i * Math.pow(1 + i, plazo))) / (Math.pow(1 + i, plazo) - 1);

  return (
    <Box>
      <PageHeader eyebrow="Cotización" title="Estima tu financiamiento" subtitle="Ajusta monto y plazo para ver una estimación de pago." />

      <Box sx={{ bgcolor: "background.paper", border: "1px solid", borderColor: "background.paper", borderRadius: 2, p: 3, display: "flex", flexDirection: "column", gap: 3 }}>
        <Box>
          <Typography variant="body2" fontWeight={600} color="primary.dark" sx={{ mb: 1 }}>
            Régimen fiscal
          </Typography>
          <RadioCardGroup
            value={regimen}
            onChange={(v) => setRegimen(v as "moral" | "fisica")}
            options={[
              { value: "moral", label: "Persona Moral", sub: "Empresa constituida (SA, SAPI, SC, etc.)", icon: <Business /> },
              { value: "fisica", label: "Persona Física Act. Emp.", sub: "Empresa PFAE", icon: <Person /> },
            ]}
          />
        </Box>

        <Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
            <Typography variant="body2" fontWeight={600} color="primary.dark">
              Monto
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {formatCurrencyWhole(MIN)} – {formatCurrencyWhole(MAX)} MXN
            </Typography>
          </Box>
          <Typography variant="h4" fontFamily="Outfit" sx={{ mb: 1 }}>
            {formatCurrencyWhole(monto)}
          </Typography>
          <Slider
            value={monto}
            min={MIN}
            max={MAX}
            step={STEP}
            onChange={(_e, v) => setMonto(v as number)}
            color="primary"
          />
        </Box>

        <Box>
          <Typography variant="body2" fontWeight={600} color="primary.dark" sx={{ mb: 1 }}>
            Plazo
          </Typography>
          <ChoiceToggle
            value={plazo}
            onChange={(v) => setPlazo(v as number)}
            options={PLAZOS.map((m) => ({ value: m, label: `${m} meses` }))}
          />
        </Box>
      </Box>

      <Box sx={{ mt: 3, p: 3, bgcolor: "primary.base", borderRadius: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Pago mensual estimado
        </Typography>
        <Typography variant="h3" fontFamily="Outfit" color="primary.dark">
          {formatCurrencyWhole(cuota)}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          MXN / mes durante {plazo} meses
        </Typography>
        <Button tone="primary" withArrow onClick={onNext}>
          Solicitar financiamiento
        </Button>
      </Box>
    </Box>
  );
};
